import React from 'react';
import styles from './Header.module.css';
import { shortenAddress } from '../../utils/utils';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

function Header({ logout, userInfo, toggleUserInfoModal }) {
  const { theme, toggleTheme } = useTheme();
  const { email, role } = useAuth();

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        {/* Reserved for breadcrumbs / search — populated by pages */}
      </div>
      <div className={styles.right}>
        <button
          type="button"
          className={styles.iconBtn}
          onClick={toggleTheme}
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
        >
          <i className={`bi ${theme === 'light' ? 'bi-moon-stars' : 'bi-sun'}`} />
        </button>

        <button
          type="button"
          className={styles.userChip}
          onClick={toggleUserInfoModal}
          title={email || 'Account'}
        >
          <span className={styles.avatar} aria-hidden="true">
            {(email || '?').slice(0, 1).toUpperCase()}
          </span>
          <span className={styles.userMeta}>
            <span className={styles.userEmail}>{email || 'Account'}</span>
            <span className={styles.userRole}>{role || 'user'}</span>
          </span>
          {userInfo?.publicAddress && (
            <span className={styles.wallet}>{shortenAddress(userInfo.publicAddress)}</span>
          )}
        </button>

        <button type="button" className={styles.logoutButton} onClick={logout}>
          <i className="bi bi-box-arrow-right" />
          <span>Sign out</span>
        </button>
      </div>
    </header>
  );
}

export default Header;
